import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** plus sign. Decorative line icon; always pair with a visible text label. */
export function PlusIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </IconSvg>
  )
}
